import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { Box, Grid, Typography } from '@mui/material';

import { gray, successGreen } from '../../constants/colors';
import './styles.scss';

function Legend() {
  return (
    <Grid container sx={{ paddingTop: 1.5, backgroundColor: 'white' }}>
      <Grid item>
        <Box className='color-guide-item'>
          <RadioButtonUncheckedIcon
            color='primary'
            fontSize='small'
            sx={{ marginRight: 1 }}
          />
          <Typography
            variant='caption'
            sx={{
              color: 'primary.main',
              fontWeight: '600',
              fontSize: '12px',
              lineHeight: 2,
            }}>
            ACTION REQUIRED
          </Typography>
        </Box>
      </Grid>
      <Grid item>
        <Box className='color-guide-item'>
          <RadioButtonUncheckedIcon
            color='disabled'
            fontSize='small'
            sx={{ marginRight: 1 }}
          />
          <Typography
            variant='caption'
            sx={{
              color: gray,
              fontWeight: '600',
              fontSize: '12px',
              lineHeight: 2,
            }}>
            NOT OPEN YET
          </Typography>
        </Box>
      </Grid>
      <Grid item>
        <Box className='color-guide-item'>
          <CheckCircleIcon
            color='success'
            fontSize='small'
            sx={{ marginRight: 1 }}
          />
          <Typography
            variant='caption'
            sx={{
              color: successGreen,
              fontWeight: '600',
              fontSize: '12px',
              lineHeight: 2,
            }}>
            COMPLETED
          </Typography>
        </Box>
      </Grid>
      <Grid item>
        <Box className='color-guide-item'>
          <Typography
            fontSize='small'
            sx={{
              color: 'primary.main',
              fontWeight: '600',
              fontSize: '12px',
              lineHeight: 2,
            }}>
            <span style={{ fontSize: '20px', lineHeight: '0px' }}>*</span>
            &nbsp;MANDATORY
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
}

export default Legend;
